export const BASE_URL = "https://eq-billingportal-api-uat.azurewebsites.net"
// export const BASE_URL = "http://172.29.135.87:8000"

export const STATUS_CHOICES = {
    'A': { label: 'Active', color: '#87d068' },
    'I': { label: 'Inactive', color: '#d9d9d9' },
    'S': { label: 'Suspended', color: '#fadb14' },
    'B': { label: 'Blocked', color: '#f5222d' },
    'D': { label: 'Deleted', color: '#595959' },
    'P': { label: 'Pending', color: '#fa8c16' },
    'C': { label: 'Completed', color: '#1890ff' },
    'R': { label: 'Rejected', color: '#ff4d4f' },
    'T': { label: 'Terminated', color: '#ff4d4f' },
    'H': { label: 'Hold', color: '#faad14' },
};

export const CURRENCIES = [
    { label: "Kenyan Shilling", value: "KES" },
    { label: "Ugandan Shilling", value: "UGX" },
    { label: "Tanzanian Shilling", value: "TZS" },
    { label: "Rwandan Franc", value: "RWF" },
    { label: "Congolese Franc", value: "CDF" },
    { label: "Ethiopian Birr", value: "ETB" },
    { label: "South Sudanese pound", value: "SSP" },
    { label: "USD", value: "USD" },
];
export const COUNTRIES = [
    { value: "KE", label: "Kenya" },
    { value: "UG", label: "Uganda" },
    { value: "TZ", label: "Tanzania" },
    { value: "SS", label: "South Sudan" },
    { value: "RW", label: "Rwanda" },
    { value: "CO", label: "DRC Congo" },
    { value: "group", label: "Group" },
];
export const STATUSES = [
    { value: 1, label: "Active" },
    { value: 0, label: "Inactive" },
];

export const ROLES = [
    { value: "STAFFMAKER", label: "Staffmaker" },
    { value: "STAFFCHECKER", label: "Staffchecker" },
    { value: "ADMIN", label: "Admin" },
    { value: "CUSTOMER_SUPPORT", label: "Customer Support" },
    { value: "RECON", label: "Reconcilliation Support" },
];